<style scoped>
    .v-content {
        padding-top: 0;
    }

    .v-subheader {
        padding-left: 0;
    }
    td {
        text-align: center;
        white-space: nowrap
    }
    td i {
        margin-right: 0 !important;
    }
</style>
<template>
    <v-app>
        <v-card>
            <v-data-table loading="true" :headers="headers" hide-actions :items="tableData" class="elevation-1">
                <template slot="items" slot-scope="props">
                    <td>
                        <a class="go-path" @click="$go_path('AnnualReview',null,{wd:props.item.name})">{{props.item.name}}</a>
                    </td>
                    <td>{{props.item.department}}</td>
                    <td>{{props.item.career}}</td>
                    <td>{{props.item.best}}</td>
                    <td>{{props.item.bad}}</td>
                </template>
                <template slot="no-data">
                    <p style="text-align: center">暂无数据</p>
                </template>
            </v-data-table>
            <v-layout row justify-center>
                <v-dialog v-model="view_dialog" scrollable max-width="300px">
                    <v-card>
                        <v-divider></v-divider>
                        <v-card-text style="height: 300px;">
                            {{desc}}
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="blue darken-1" flat @click="view_dialog = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-card>

    </v-app>
</template>

<script>
	export default {
		components: {},
		data: () => ({
			search: '',
			desc:'',
			view_dialog: false,
			headers: [
				{text: '姓名', align: 'center', value: 'name', sortable: false},
				{text: '部门', align: 'center', value: 'department', sortable: false},
				{text: '职位', align: 'center', value: 'career', sortable: false},
				{text: '最好', align: 'center', value: 'best'},
				{text: '最差', align: 'center', value: 'bad'},
				// {text: '详情', align: 'left', value: 'action'},
			],
			tableData: [],
		}),
		created(){
	        // let url = `http://pape.paquapp.com/searchUserEvaluate/?name=${this.search}`
	        let url = "http://pape.paquapp.com/userBestBadList/";
	        this.$axios.get(url).then((response) => {
		        this.tableData = response
	        });
        },

		methods: {
        }
	}
</script>